<template>

  <div class="card">
    <div class="card-header">
      <p class="card-header-title">Modifier</p>
      <span class="icon has-text-info help-btn">
        <a href="https://theadmin.thecompagnie.eu/doc?bloc=Type%20de%20contenu%20unique" target="_blank"><i class="fa fa-question-circle"></i></a>
      </span>
    </div>
    <div class="card-content">
      <div class="content">
        <div class="columns">
          <div class="column">

            <!-- Textbox fields -->
            <div class="field" v-for="(field, index) in fields" :key="index" v-if="field.type === 'textbox'">
              <label class="label">{{ field.name }}</label>
              <div class="control">
                <input type="text" class="input" maxlength="25" required :placeholder="field.name" v-model="content[field.name]">
              </div>
            </div>

            <!-- Textarea fields -->
            <div class="field" v-for="(field, index) in fields" :key="index" v-if="field.type === 'textarea'">
              <label class="label">{{ field.name }}</label>
              <div class="control">
                <textarea class="input" v-model="content[field.name]" :placeholder="field.name" v-text="content[field.name]"></textarea>
              </div>
            </div>

            <!-- Rich text fields - vue-quill-editor plugin -->
            <div class="field" v-for="(field, index) in fields" :key="index" v-if="field.type === 'richtextbox'">
              <label class="label">{{ field.name }}</label>
              <quill-editor v-model="content[field.name]" :options="editorOptions">
              </quill-editor>
              <input type="file" id="getImage" style="display: none;" @change="uploadImage">
            </div>

            <!-- Category fields -->
            <br>
            <div class="field" v-for="(field, index) in fields" :key="index" v-if="field.type === 'select'">
              <label class="label">{{ field.name }}</label>
              <div class="control">
                <input type="text" class="input" :placeholder="field.name" v-model="content[field.name]" maxlength="25">
              </div>
            </div>

            <!-- Tag fields -->
            <div class="field" v-for="(field, index) in fields" :key="index" v-if="field.type === 'tags'">
              <label class="label">{{ field.name }}</label>
              <div class="control">
                <div class="tags tagscontainer">
                <span @click="removeTag(tagKey, field.name)" v-for="(tag, tagKey) in content[field.name]" :key="tagKey" class="tag is-info pointer">{{tag}}<button class="delete is-small"></button></span>
                <input :placeholder="field.name" @keyup.enter="styleTags(field.name)" type="text" class="input" maxlength="25" v-model="inputData">
                </div>
                <p>Séparer les tags avec des virgules ","</p>
              </div>
            </div>

            <!-- Image fields -->
            <div class="field" v-for="(field, index) in fields" :key="index" v-if="field.type === 'image'">
              <label class="label">{{ field.name }}</label>
              <div class="control">
                <p v-if="imageUploadedModif">
                  <img :src="imageUploadedModifUrl">
                  Image modifiée
                </p>
                <img v-else :src="content[field.name]">
                <div class="file">
                  <label class="file-label">
                    <input @change="uploadFeaturedImage($event, field.name)" class="file-input" type="file" name="resume">
                    <span class="file-cta">
                      <span class="file-icon">
                        <i class="fa fa-upload"></i>
                      </span>
                      <span class="file-label">
                        Télécharger
                      </span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- notification -->
        <div v-if="notification.message" :class="'notification is-' + notification.type">
          <button class="delete" @click="hideNotifications"></button>{{notification.message}}
        </div>

         <!-- the form buttons -->
        <button v-if="content.state === 'saved'" type="submit" class="button is-success" @click="update(true)">Actualiser et publier</button>
        <button type="submit" class="button is-info" @click="update(false)">Actualiser</button>
        <router-link :to="'/admin/content/' + $route.params.key" class="button is-danger">Annuler</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'

import { mediaRef } from '@/admin/firebase_config'
import editorOptions from '@/admin/utils/editor-options'
import imageLoader from '@/admin/mixins/image-loader'
import notifier from '@/admin/mixins/notifier'

export default {
  name: 'content-edit',
  data () {
    return {
      /* Here we are filtering out the post containing the provided key in the router params
       * we are using Object.assign to copy the post by value not by reference
       * to prevent updating the poste when typing */
      inputData: '',
      imageUploadedModif: false,
      imageUploadedModifUrl: '',
      editorOptions
    }
  },
  firebase: {
    media: mediaRef
  },
  props: ['contents', 'update-content', 'fields'],
  mixins: [imageLoader, notifier],
  computed: {
    content () {
      return Object.assign(
        {},
        (this.contents.filter((c) => {
          return (c['.key'] === this.$route.params.contentKey)
        }))[0]
      )
    }
  },
  methods: {
    update (publish) {
      if (publish) {
        this.content.state = 'published'
      }
      this.content.img = this.imageUploadedModifUrl
      this.updateContent(this.content)
      this.imageUploadedModif = false
    },
    uploadFeaturedImage (e) {
      let file = e.target.files[0]
      let storageRef = firebase.storage().ref('images/' + file.name)

      const that = this

      storageRef.put(file).then((snapshot) => {
        that.content.img = snapshot.downloadURL
        const imageExist = Object.values(this.media).find(e => e.path === snapshot.ref.fullPath) // this detect if media already exist and replace values for existing ones
        if (imageExist) {
          that.content.img = imageExist.src
          this.imageUploadedModifUrl = imageExist.src
        } else {
          this.$firebaseRefs.media.push({
            src: snapshot.downloadURL,
            path: snapshot.ref.fullPath,
            name: snapshot.metadata.name
          })
          that.content.img = snapshot.downloadURL
          this.imageUploadedModifUrl = snapshot.downloadURL
        }
        this.imageUploadedModif = true
      })
    },
    styleTags (fieldName) {
      if (this.inputData !== '') {
        if (!this.content[fieldName]) {
          this.content[fieldName] = []
        }
        this.content[fieldName].push(`${this.inputData.trim()}`)
        this.inputData = ''
      }
    },
    removeTag (index, fieldName) {
      this.content[fieldName].splice(index, 1)
    }
  }
}

</script>
<style lang="scss" scoped>
.section{
  padding: 0 !important;
  padding-top: 1em !important;
}
.bulma .card .card-content.principal{
  padding: 0 !important;
}
.bulma .card-content{
  padding: 0 !important;
}
.bulma .columns{
  padding: 0 !important;
}
.bulma .column{
  padding: 0 !important;
}
.content{
  padding: 1em !important;
}
</style>



// WEBPACK FOOTER //
// src/admin/pages/content/contents/ContentsEdit.vue